const styles = theme => ({
    root: {
      width: '100%',
      margin: theme.spacing.unit * 3 + 'px auto',
      marginTop: theme.spacing.unit,
      padding: theme.spacing.unit * 3,
      paddingTop: 0,
      boxSizing: 'border-box',
      position: 'relative',
    },
    loader: {
      position: 'absolute',
      top: '1.5rem',
      right: '1.5rem',
    },
    filters: {
      flexGrow: 1,
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
    },
    tableWrapper: {
      overflowX: 'auto',
    },
    tableHead: {
      borderBottom: 'none',
      borderTop: '1px solid #f2f2f2',
    },
    tableBody: {
      borderBottom: '1px solid #f2f2f2',
    },
    tableRow: {
      textOverflow: 'ellipsis',
      overflowX: 'hidden',
      cursor: 'pointer',
    },
    bold: {
      'font-weight': 'bold',
    },
    tableCell: {
      maxWidth: '100px',
      overflowX: 'hidden',
      padding: theme.spacing.unit,
    },
    tableCellLast: {
      paddingRight: '8px !important',
    },
    iconInTable: {
      // color:"#2EA243"
      color: theme.palette.primary.A700
    },
    footer: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-end',
      boxSizing: 'border-box',
    },
    pending: {
      color: theme.palette.common.accentOrange,
    },
    input: {
      opacity: 0.54,
      '&:hover': {
        opacity: 1,
      },
    },
  });

export default styles



// WEBPACK FOOTER //
// ./src/modules/common/components/table/styles.js